/** Gets session customized component images (frontseat, backseat and steering wheel) for screen-interior  */
function getInteriorImageForStoredComponent(componentType, component, colorCode){
	let json = {};
	let filteredComponent = component.replace("Color", "");

	switch (componentType) {
		case 'car_interior':
			const interiorFrontAndBack = getInteriorCustomizedComponentImage(component, colorCode)
			json.front_interior_image = interiorFrontAndBack.front
			json.back_interior_image = interiorFrontAndBack.back
			
			break;
		case 'steering_wheel':
			let steeringWheelModel = document.getElementsByName("steering-wheel-model")[0].value
			let isHourMarkSteeringWheel = aeo['configuration']['YVN'] == true || aeo['configuration']['0UD_A5'] == true 
			let isHourMarkSteeringWheelWithout = aeo['configuration']['YVN_without12h'] == true  || aeo['configuration']['YVQ_etronGT'] == true 
			
			if ((steeringWheelModel <= 2) && (document.getElementsByName("carmodel")[0].value <= 2)) {
				if (steeringWheelModel == null || steeringWheelModel == "") return "";
				if (isHourMarkSteeringWheel) {				
					if(['hourMarkColor','stitchHourMarkColor'].indexOf(component) != -1){
						json.image = aeo['images'][component == 'hourMarkColor' ? 'interior_hour_mark_steering_wheel' : 'interior_stitch_hour_mark_steering_wheel'][colorCode]
					}
				}else{
					if (['hourMarkColor', 'stitchHourMarkColor'].indexOf(component) != -1) return ""; //invalid component 
					if (steeringWheelModel == 1){
						json.image = aeo['paths']['interior_steering_wheel_one'][colorCode] + aeo['components']['steering_wheel'][component]
					}else{
						json.image = aeo['paths']['interior_steering_wheel_two'][colorCode] + aeo['components']['steering_wheel'][component]
					}
				}
			} 
			/* wenn kein e-tron und kein Lenkrad ausgewählt, zeige Basis-Lenkradbild des Fahrzeugmodells */
			else if ((steeringWheelModel < 3) && (document.getElementsByName("carmodel")[0].value > 2)) { 
				json.image = aeo['paths']['interior_basis_steering_wheel_2ZB'];
			}

			if ((steeringWheelModel == 101) && (document.getElementsByName("modelcategory")[0].value == 'e-tron_gt')) {  
				if (steeringWheelModel == null || steeringWheelModel == "") return "";
				if (isHourMarkSteeringWheel) {				
					if(['hourMarkColor','stitchHourMarkColor','topColor'].indexOf(component) != -1){
					   switch (component) {
						   case 'hourMarkColor':
							   json.image = aeo['images']['interior_hour_mark_steering_wheel_onehundreone'][colorCode]
							   break;
						   case 'topColor':
							   //json.image = aeo['images']['interior_topColor_steering_wheel_onehundreone'][colorCode]	
							   if (isHourMarkSteeringWheelWithout) { 
								   json.image = 'img/01_interieur/yvu-yvn_lenkrad/lenkrad_yvn_1xy_12uhr/au513_e-tron_gt_lenkrad_yve_1xy_schwarz_basis.png' 
							   }
							   break;
						   case 'stitchHourMarkColor':
							   json.image = aeo['images']['interior_stitch_hour_mark_steering_wheel_onehundreone'][colorCode]
							   break;
						   default:
							   json.image = 'unknown_component';
					   }
					}
				}else{	
					if (['hourMarkColor', 'stitchHourMarkColor'].indexOf(component) != -1) return ""; //invalid component 
					json.image = aeo['paths']['interior_steering_wheel_onehundredone'][colorCode] + aeo['components']['steering_wheel'][component]
				}
			}
			
			if ((steeringWheelModel == 102) && (document.getElementsByName("modelcategory")[0].value == 'e-tron_gt')) { 
				if (steeringWheelModel == null || steeringWheelModel == "") return "";
				if (isHourMarkSteeringWheel || isHourMarkSteeringWheelWithout) {		
					if(['hourMarkColor','stitchHourMarkColor','topColor'].indexOf(component) != -1){
					   switch (component) {
						   case 'hourMarkColor':
							   json.image = aeo['images']['interior_hour_mark_steering_wheel_onehundretwo'][colorCode]
							   break;
						   case 'topColor':
							   json.image = aeo['images']['interior_topColor_steering_wheel_onehundretwo'][colorCode]	
							   if (isHourMarkSteeringWheelWithout) { 
								   json.image = 'img/01_interieur/yvu-yvn_lenkrad/lenkrad_yvn_2zc_12uhr/au513_e-tron_gt_lenkrad_yve_2zc_schwarz_basis.png' 
							   }
							   break;
						   case 'stitchHourMarkColor':
							   json.image = aeo['images']['interior_stitch_hour_mark_steering_wheel_onehundretwo'][colorCode]
							   break;
						   default:
							   json.image = 'unknown_component';
					   }
				   }
				}else{
					if (['hourMarkColor', 'stitchHourMarkColor'].indexOf(component) != -1) return ""; //invalid component 
					json.image = aeo['paths']['interior_steering_wheel_onehundredtwo'][colorCode] + aeo['components']['steering_wheel'][component]
				}
			} 
										  
			if ((steeringWheelModel == 103) && (document.getElementsByName("modelcategory")[0].value == 'e-tron_gt')) {				
				if (steeringWheelModel == null || steeringWheelModel == "") return "";
				if (isHourMarkSteeringWheel || isHourMarkSteeringWheelWithout) {											   
					if(['hourMarkColor','stitchHourMarkColor','topColor'].indexOf(component) != -1){
					   switch (component) {
						   case 'hourMarkColor':
							   json.image = aeo['images']['interior_hour_mark_steering_wheel_onehundrethree'][colorCode]
							   break;
						   case 'stitchesColor':
							   json.image = aeo['images']['interior_topColor_steering_wheel_onehundrethree'][colorCode]	
							   if (isHourMarkSteeringWheelWithout) { 
								   json.image = 'img/01_interieur/yvu-yvn_lenkrad/lenkrad_yvu_2fj/au513_e-tron_gt_lenkrad_yvu_2fj_schwarz_basis.png' 
							   }
							   break;
						   case 'stitchHourMarkColor':
							   json.image = aeo['images']['interior_stitch_hour_mark_steering_wheel_onehundrethree'][colorCode]
							   break;
						   default:
							   json.image = 'unknown_component';
					   }
				   }
				}else{
					
					if(['stitchesColor'].indexOf(component) != -1){
						json.image = aeo['paths']['interior_steering_wheel_onehundredthree'][colorCode] + aeo['components']['steering_wheel'][component]
					}
				}
			} 	
										  
			/*
			if ((steeringWheelModel == 107) && (document.getElementsByName("modelcategory")[0].value == 'e-tron_gt')) {				
				if (steeringWheelModel == null || steeringWheelModel == "") return "";				
					if(['stitchesColor'].indexOf(component) != -1){
						json.image = aeo['paths']['interior_steering_wheel_onehundredthree'][colorCode] + aeo['components']['steering_wheel'][component]
					}
			} 		
			*/	 
			if (steeringWheelModel == 107) {
				let isHourMarkSteeringWheel = aeo['configuration']['YVQ_etronGT'] == true;
				if (steeringWheelModel == null || steeringWheelModel == "") return "";
					if(['stitchesColor'].indexOf(component) != -1){
						json.image = aeo['paths']['model_YVQ_etronGT_car_steering_wheel_interior'][colorCode] + aeo['components']['steering_wheel'][component]
					}
					if(['top'].indexOf(component) != -1){
						json.image = aeo['paths']['topColor_steering_wheel_YVQ_etronGT_interior'][colorCode] + aeo['components']['steering_wheel'][component]
					}
					if (['bottomColor'].indexOf(component) != -1) {
						json.image = aeo['paths']['basis_steering_wheel_YVQ_etronGT_interior'][colorCode];
					}
			}




			let isGearLever = aeo['configuration']['YVU'] == true
			let isAirbagCover = aeo['configuration']['YUH'] == true	
			var CheckmodelCategory = document.querySelector("input[name=modelcategory]").value

			if (steeringWheelModel == 3){

				if(component == 'bottomColor'){
					json.image = aeo['paths']['interior_basis_steering_wheel_2ZB'];	
				}else if (component == 'GearLeverStitchesColor') {
					if((CheckmodelCategory != 'q8') && (CheckmodelCategory != 'Q8_etron')) {
						json.image = aeo['paths']['interior_A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];
					}		
				}else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				} else if (isAirbagCover) {
						if (component == 'AirbagCoverLeatherColor') {
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]	
						}else if(component == 'AirbagCoverStitchesColor'){				
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
						}		
				}
				
				
					
			} else if (steeringWheelModel == 4){
					//json.image = aeo['paths']['interior_steering_wheel_1XW_1XP_L'][colorCode] + aeo['components']['steering_wheel_1'][component]

					if(component == 'bottomColor'){
						json.image = aeo['paths']['interior_basis_steering_wheel_1XW_1XP_L'];	
					}else if (component == 'GearLeverStitchesColor') {
						if((CheckmodelCategory != 'q8') && (CheckmodelCategory != 'Q8_etron')) {
							json.image = aeo['paths']['interior_A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];	
						}	
					}else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_1XW_1XP_L'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					} else if (isAirbagCover) {
						if (component == 'AirbagCoverLeatherColor') {
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
						}else if(component == 'AirbagCoverStitchesColor'){				
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
						}		
					}

			} else if (steeringWheelModel == 5){
					//json.image = aeo['paths']['interior_steering_wheel_1XW_1XP_P'][colorCode] + aeo['components']['steering_wheel_1'][component]

					if(component == 'bottomColor'){
						json.image = aeo['paths']['interior_basis_steering_wheel_1XW_1XP_P'];	
					}else if (component == 'GearLeverStitchesColor') {
						if((CheckmodelCategory != 'q8') && (CheckmodelCategory != 'Q8_etron')) {
							json.image = aeo['paths']['interior_A6A7_gear_lever_2'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];	
						}	
					}else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_1XW_1XP_P'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					} else if (isAirbagCover) {
						if (component == 'AirbagCoverLeatherColor') {
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
						}else if(component == 'AirbagCoverStitchesColor'){				
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
						}		
					}

			} else if (steeringWheelModel == 6){
					//json.image = aeo['paths']['interior_steering_wheel_2PF_L'][colorCode] + aeo['components']['steering_wheel_1'][component]

					if(component == 'bottomColor'){
						json.image = aeo['paths']['interior_basis_steering_wheel_2PF_P'];	
					}else if (component == 'GearLeverStitchesColor') {
						if((CheckmodelCategory != 'q8') && (CheckmodelCategory != 'Q8_etron')) {
							json.image = aeo['paths']['interior_A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];
						}			
					}else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_2PF_P'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					} else if (isAirbagCover) {
						if (component == 'AirbagCoverLeatherColor') {
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
						}else if(component == 'AirbagCoverStitchesColor'){				
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
						}		
					}
			} else if (steeringWheelModel == 7){
					//json.image = aeo['paths']['interior_steering_wheel_2PF_P'][colorCode] + aeo['components']['steering_wheel_1'][component]

					if(component == 'bottomColor'){
						json.image = aeo['paths']['interior_basis_steering_wheel_2PF_L'];	
					}else if (component == 'GearLeverStitchesColor') {
						if((CheckmodelCategory != 'q8') && (CheckmodelCategory != 'Q8_etron')) {
							json.image = aeo['paths']['interior_A6A7_gear_lever_2'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];
						}		
					}else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_2PF_L'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					} else if (isAirbagCover) {
						if (component == 'AirbagCoverLeatherColor') {
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
						}else if(component == 'AirbagCoverStitchesColor'){				
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
						}		
					}
			} else if (steeringWheelModel == 8){
					//json.image = aeo['paths']['interior_steering_wheel_1XPF'][colorCode] + aeo['components']['steering_wheel_1'][component]

					if(component == 'bottomColor'){
						json.image = aeo['paths']['interior_basis_steering_wheel_1XPF'];	
					}else if (component == 'GearLeverStitchesColor') {
						json.image = aeo['paths']['interior_A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];		
					}else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_1XPF'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					} else if (isAirbagCover) {
						if (component == 'AirbagCoverLeatherColor') {
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
						}else if(component == 'AirbagCoverStitchesColor'){				
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
						}		
					}
			} else if (steeringWheelModel == 9){
					//json.image = aeo['paths']['interior_steering_wheel_2PZ'][colorCode] + aeo['components']['steering_wheel_1'][component]

					if(component == 'bottomColor'){
						json.image = aeo['paths']['interior_basis_steering_wheel_2PZ'];	
					}else if (component == 'GearLeverStitchesColor') {
						json.image = aeo['paths']['interior_A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];		
					}else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_2PZ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					} else if (isAirbagCover) {
						if (component == 'AirbagCoverLeatherColor') {
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
						}else if(component == 'AirbagCoverStitchesColor'){				
							json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
						}		
					}

					// let isGearLever = aeo['configuration']['YVU'] == true

			} else if (steeringWheelModel == 10){
				if(component == 'bottomColor'){
					json.image = aeo['paths']['interior_basis_R6R7_steering_wheel_2PZ'];
				}else if (component == 'GearLeverStitchesColor') {
					json.image = aeo['paths']['interior_A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1']['GearLeverStitches'];		
				}else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_2PZ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				} else if (isAirbagCover) {
					if (component == 'AirbagCoverLeatherColor') {
						json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
					}else if(component == 'AirbagCoverStitchesColor'){				
						json.image = aeo['paths']['interior_airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
					}		
				}

				// let isGearLever = aeo['configuration']['YVU'] == true
		
			} else if (steeringWheelModel == 13){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q7_Q8_1XW_YVU'];		
				} else if(component == 'stitchesColor'){
					if (aeo['configuration']['YVU_Q7Q8'] == true) {	
						json.image = aeo['paths']['interior_steering_wheel_Q7_Q8_1XW_YVU'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					} else {
						json.image = aeo['paths']['interior_steering_wheel_Q7_Q8_Sport_Lenkrad_1XW_YVQ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					}
				}
			} else if (steeringWheelModel == 14){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_SQ7_SQ8_1XW_YVU'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_SQ7_SQ8_1XW_YVU'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 15){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_SQ7_SQ8_Sportkontur_Lenkrad_2PF_YVU'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_SQ7_SQ8_Sportkontur_Lenkrad_2PF_YVU'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}

			} else if (steeringWheelModel == 16){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_RSQ8_Sport_Lenkrad_1XW_YVU'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_RSQ8_Sport_Lenkrad_1XW_YVU'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 17){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Sportkontur_Lenkrad_2PF_YVU'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_Sportkontur_Lenkrad_2PF_YVU'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 18){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q7_Q8_Sport_Lenkrad_1XW_YVQ'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_Q7_Q8_Sport_Lenkrad_1XW_YVQ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 19){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_SQ7_SQ8_Sport_Lenkrad_1XW_YVQ'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_SQ7_SQ8_Sport_Lenkrad_1XW_YVQ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 20){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_SQ7_SQ8_Sportkontur_Lenkrad_2PF_YVQ'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_SQ7_SQ8_Sportkontur_Lenkrad_2PF_YVQ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 21){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_RSQ8_Sport_Lenkrad_1XW_YVQ'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_RSQ8_Sport_Lenkrad_1XW_YVQ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 22){
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_RSQ8_Sportkontur_Lenkrad_2PF_YVQ'];		
				} else if(component == 'stitchesColor'){					
					json.image = aeo['paths']['interior_steering_wheel_RSQ8_Sportkontur_Lenkrad_2PF_YVQ'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}		

			// A8	
			} else if (steeringWheelModel == 51){	
				if (aeo['configuration']['YVU_A8'] == false) { // wenn kein YVU ausgewählt, dann kein Wählheber darstellen	
					if(component == 'bottomColor'){					
						json.image = aeo['paths']['interior_basis_A8_4_speichen_Schwarz_Lenkrad_2ZB'];		
					} else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_A8_3_speichen_Schwarz_Lenkrad_2ZB_ohne_waehlheber'][colorCode];	
					}	
				} else {
					if(component == 'bottomColor'){					
						json.image = aeo['paths']['interior_basis_A8_4_speichen_Schwarz_Lenkrad_2ZB'];		
					} else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_A8_4_speichen_Schwarz_Lenkrad_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component];
					}
				}
				
			} else if (steeringWheelModel == 52){	
				
				if (aeo['configuration']['YVU_A8'] == false) { // wenn kein YVU ausgewählt, dann kein Wählheber darstellen	
					if(component == 'bottomColor'){					
						json.image = aeo['paths']['interior_basis_A8_3_speichen_Schwarz_Lenkrad_1XW'];		
					} else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_A8_3_speichen_Schwarz_Lenkrad_1XW_ohne_waehlheber'][colorCode];	
					}	
				} else {
					if(component == 'bottomColor'){					
						json.image = aeo['paths']['interior_basis_A8_3_speichen_Schwarz_Lenkrad_1XW'];		
					} else if(component == 'stitchesColor'){					
						json.image = aeo['paths']['interior_steering_wheel_A8_3_speichen_Schwarz_Lenkrad_1XW'][colorCode] + aeo['components']['steering_wheel_1'][component];	
					}
				}

			//Q6 e-tron	
			} else if (steeringWheelModel == 60){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q6_etron_2ZB_SteeringWheel'];	
				} else if(component == 'stitchesColor'){				
					json.image = aeo['paths']['interior_steering_wheel_Q6_etron_2ZB_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}			
			} else if (steeringWheelModel == 61){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q6_etron_2FS_SteeringWheel'];
				} else if(component == 'stitchesColor'){			
					json.image = aeo['paths']['interior_steering_wheel_Q6_etron_2FS_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 62){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q6_etron_1XY_SteeringWheel'];		
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_Q6_etron_1XY_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}

			// SQ6 e-tron performance
			} else if (steeringWheelModel == 63){
				if(component == 'bottomColor'){
					json.image = aeo['paths']['interior_basis_steering_wheel_SQ6_perf_6F6_SteeringWheel'];
				} else if(component == 'stitchesColor'){
					json.image = aeo['paths']['interior_steering_wheel_SQ6_perf_6F6_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];
				} else if(component == 'hourMarkColor'){
					json.image = aeo['images']['interior_hour_mark_steering_wheel_SQ6_perf_6F6_SteeringWheel'][colorCode]
				}
			} else if (steeringWheelModel == 64){
				if(component == 'bottomColor'){
					json.image = aeo['paths']['interior_basis_steering_wheel_SQ6_perf_6F9_SteeringWheel'];
				} else if(component == 'stitchesColor'){
					json.image = aeo['paths']['interior_steering_wheel_SQ6_perf_6F9_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];
				} else if(component == 'hourMarkColor'){
					json.image = aeo['images']['interior_hour_mark_steering_wheel_SQ6_perf_6F9_SteeringWheel'][colorCode]
				}

			//A5	
			} else if (steeringWheelModel == 70){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A5_2ZQ_SteeringWheel'];	
				} else if(component == 'stitchesColor'){				
					json.image = aeo['paths']['interior_steering_wheel_A5_2ZQ_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}			
			} else if (steeringWheelModel == 71){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A5_2FS_SteeringWheel'];
				} else if(component == 'stitchesColor'){			
					json.image = aeo['paths']['interior_steering_wheel_A5_2FS_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 72){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A5_1XY_SteeringWheel'];		
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_A5_1XY_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			
			} else if (steeringWheelModel == 73){	
				
				if(component == 'topColor'){	
					json.image = aeo['paths']['interior_steering_wheel_RS5_2ZC_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];
				} else if(component == 'bottomColor'){					
					//json.image = aeo['paths']['interior_basis_steering_wheel_RS5_2ZC_SteeringWheel'];			
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_RS5_2ZC_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				} else if(component == 'hourMarkColor'){		
					json.image = aeo['images']['interior_hour_mark_steering_wheel_RS5_2ZC_SteeringWheel'][colorCode]
				}
			
			} else if (steeringWheelModel == 74){	
				
				if(component == 'topColor'){	
					json.image = aeo['paths']['interior_steering_wheel_RS5_2ZC_Dinamica_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];
				} else if(component == 'bottomColor'){					
					//json.image = aeo['paths']['interior_basis_steering_wheel_RS5_2ZC_SteeringWheel'];			
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_RS5_2ZC_Dinamica_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				} else if(component == 'hourMarkColor'){		
					json.image = aeo['images']['interior_hour_mark_steering_wheel_RS5_2ZC_Dinamica_SteeringWheel'][colorCode]
				}

			//A6 etron	
			} else if (steeringWheelModel == 80){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A6_etron_2ZQ_SteeringWheel'];	
				} else if(component == 'stitchesColor'){				
					json.image = aeo['paths']['interior_steering_wheel_A6_etron_2ZQ_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}			
			} else if (steeringWheelModel == 81){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A6_etron_2FS_SteeringWheel'];
				} else if(component == 'stitchesColor'){			
					json.image = aeo['paths']['interior_steering_wheel_A6_etron_2FS_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 82){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A6_etron_1XY_SteeringWheel'];		
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_A6_etron_1XY_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}

			//A7 C9	
			} else if (steeringWheelModel == 90){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A6_C9_2ZQ_SteeringWheel'];			
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_A6_C9_2ZQ_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}			
			} else if (steeringWheelModel == 91){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A6_C9_2FS_SteeringWheel'];
				} else if(component == 'stitchesColor'){			
					json.image = aeo['paths']['interior_steering_wheel_A6_C9_2FS_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 92){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_A6_C9_1XY_SteeringWheel'];		
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_A6_C9_1XY_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}

			//Q7/Q9 G8	
			} else if (steeringWheelModel == 104){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q7Q9_2ZQ_SteeringWheel'];			
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_Q7Q9_2ZQ_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}			
			} else if (steeringWheelModel == 105){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q7Q9_2FS_SteeringWheel'];
				} else if(component == 'stitchesColor'){			
					json.image = aeo['paths']['interior_steering_wheel_Q7Q9_2FS_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			} else if (steeringWheelModel == 106){	
				if(component == 'bottomColor'){					
					json.image = aeo['paths']['interior_basis_steering_wheel_Q7Q9_1XY_SteeringWheel'];		
				} else if(component == 'stitchesColor'){	
					json.image = aeo['paths']['interior_steering_wheel_Q7Q9_1XY_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component];	
				}
			}
			break;

		case 'car_frontseat':
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
			var modelCategory = document.querySelector("input[name=modelcategory]").value
			/*if(aeo['configuration']['YVJ']== true){
				json.image = ""
				break;
			}*/
			if (['frontSeat', 'seatCenterSectionBottom', 'upholsteryBarOutside',
       'rearCenterArmrest','centerHeadrestFront','centerHeadrestSide','centerHeadrestRear'].indexOf(filteredComponent) == -1 && aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]) {  //invalid component 
				if (filteredComponent == 'backrestTop' && (frontSeatModel == "Q1D" || frontSeatModel == "Q1D_AU53X")) {
					filteredComponent = 'backrestTop'
					if(document.querySelector("input[name=carmodel]").value == "7") { // set allroad embossing
						filteredComponent = 'backrestTopAllroad'
					} else if (document.querySelector("input[name=carmodel]").value != "3" && 
								document.querySelector("input[name=carmodel]").value != "5" && 
								document.querySelector("input[name=carmodel]").value != "11") { // set s-line embossing
						filteredComponent = 'backrestTopSline'
					} 
				}
				if (filteredComponent == 'shoulderArch' && (frontSeatModel == "Q1D_AU65X")) {
					filteredComponent = 'shoulderArch'
					if (document.querySelector("input[name=carmodel]").value != "22" && 
						document.querySelector("input[name=carmodel]").value != "24" ) { // set s-line embossing
						filteredComponent = 'shoulderArchSline'
					} 
				}
				if (modelCategory == 'a8') { // Modelcatgory A8 
					switch(filteredComponent) {
						case 'shoulderArch':
							if(frontSeatModel == "Q1D_AU65X") {
								json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							}
							json.front_interior_image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break;
						case 'headrestFront':
							if((frontSeatModel == "Q2J_AU65X") || (frontSeatModel == "Q2J_RAUTE_AU65X")) {
								json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							}
							json.front_interior_image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break;
						case 'biese':
						case 'headrestRear':
						case 'headrestSide':
						case 'headrestFront':
						case 'contrastStitchingSide':
						case 'backrestCover':
						case 'seatSideBolstersOutside':
						case 'circumferentialBand':
							json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							json.front_interior_image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break;
						default:
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break; 
					}
				} else if (modelCategory == 'q6_etron') { // Modelcatgory Q6 
					switch(filteredComponent) {
						case 'circumferentialBand03':
						case 'seatSideBolstersOutside05':
						case 'seatSideBolstersOutside03':
						case 'seatSideBolstersOutside02':
						case 'contrastStitchingSide':
						case 'headrestFront':
						case 'headrestSide':
						case 'headrestRear':
							json.image = ""
							json.front_interior_image_back = ""
							json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]	
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break;
						default:
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break; 
					}
				} else if (modelCategory == 'a6_etron') { // Modelcatgory A6 etron 
					switch(filteredComponent) {
						case 'circumferentialBand03':
						case 'seatSideBolstersOutside05':
						case 'seatSideBolstersOutside03':
						case 'seatSideBolstersOutside02':
						case 'contrastStitchingSide':
						case 'headrestFront':
						case 'headrestSide':
						case 'headrestRear':
							json.image = ""
							json.front_interior_image_back = ""
							json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]	
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							break;
						default:
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break; 
					}
				} else if ((modelCategory == 'a5') || (modelCategory == 'a6_c9')) { // Modelcatgory A5 and A6 C9
					switch(filteredComponent) {
						case 'headrestFront':
						case 'headrestSide':
						case 'shoulderArch':
						case 'circumferentialBand03':
						case 'seatSideBolstersOutside':
						case 'seatSideBolstersOutside03':
						case 'contrastStitchingSide':
							json.image = ""
							json.front_interior_image_back = ""
							json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]	
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break;
						default:
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break; 
					}
				} else if (modelCategory == 'q7_g8' || modelCategory == 'q9_g8') { // Modelcatgory Q7 und Q9
					var q1dembossingQ7 = (document.querySelector("input[name=q1dembossing]") || {}).value || "";
					var useSlineQ7 = q1dembossingQ7 && filteredComponent == 'headrestFront';
					var frontComponentKeyQ7 = useSlineQ7
						? 'interior_screen_front'+seatComponentSelection+q1dembossingQ7
						: 'interior_screen_front'+seatComponentSelection;
					switch(filteredComponent) {
						case 'headrestFront':
						case 'headrestSide':
						case 'headBoxSide':
						case 'headrestStitching':
						case 'circumferentialBand03':
						case 'contrastStitchingSide':
							json.image = ""
							json.front_interior_image_back = ""
							json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components'][frontComponentKeyQ7][filteredComponent]
						break;
						default:
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break;
					}
				}else { // Modelcatgory all other
					switch(filteredComponent) {
						case 'biese':
							json.image = ""
							if ((aeo['configuration']['YYA'] == true) || (aeo['configuration']['N0Q'] == true)) {
								json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_biese'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							}
						break;
						case 'embossing':
							json.image = ""
							if (aeo['configuration']['YTY'] == true) {
								json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_embossing'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							}
						break; 
						case 'contrastStitchingSeatCover':
						case 'seatCover':
							json.image = ""
							if (aeo['configuration']['YQN'] == true) {
								json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_seatCover'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							}
						break; 
						case 'shoulderArch':
						case 'shoulderArchSline':
							if(frontSeatModel == "Q4Q" || frontSeatModel == "Q4Q_RS") {
								json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							}
							json.front_interior_image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]	
						break;
						case 'shoulderBolsters':
							if(frontSeatModel.indexOf("Q2J") != -1) {
								json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
							}
							json.front_interior_image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]	
						break;
						case 'backrestTop':
						case 'backrestTopAllroad':
						case 'backrestTopSline':
							if(frontSeatModel == "Q1D") {
								json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection]['backrestTop']
							}
							json.front_interior_image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]	
						break;
						case 'circumferentialBand':
						case 'seatSideBolstersOutside':
						case 'contrastStitchingCenterHeadrest':
						case 'contrastStitchingSide':
						case 'headrestFront':
						case 'headrestFront2':
						case 'headrestSide':
							var q1dembossingInt = (document.querySelector("input[name=q1dembossing]") || {}).value || "";
							var frontEmbossingVariant = aeo['components']['interior_screen_front'+seatComponentSelection+q1dembossingInt];
							var useSlineHeadrest = q1dembossingInt && filteredComponent == 'headrestFront' && modelCategory != 'a8'
								&& !!frontEmbossingVariant && frontEmbossingVariant[filteredComponent] !== undefined;
							var frontComponentKey = useSlineHeadrest
								? 'interior_screen_front'+seatComponentSelection+q1dembossingInt
								: 'interior_screen_front'+seatComponentSelection;
							if(frontSeatModel.indexOf("Q1J") == -1) {
								if(modelCategory == 'q7') {
									json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_5KA_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
								} else {
									json.front_interior_image_back = aeo['paths'][componentType+'_'+frontSeatModel+'_back'][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
								}
							}
							json.front_interior_image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components'][frontComponentKey][filteredComponent]
						break;
						default:
							json.image = aeo['paths'][componentType+'_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][filteredComponent]
						break; 
					}
				}
				
			} else {
				json.image = ""
			}
			break;
		case 'car_backseat':
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			var seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
			var carModel = document.querySelector("input[name=carmodel]").value;
			/*if (aeo['configuration']['YVJ'] == true) {
				json.image = ""
				break;
			}*/
			if (['frontSeat'].indexOf(filteredComponent) == -1 && aeo['components']['interior_screen_back'+seatComponentSelection][filteredComponent]) {  //invalid filteredComponent 
				switch(filteredComponent) {
					case 'backrestTop':
						json.image = ""
						if (carModel=='21' && aeo['configuration']['YZ1_Q7Q8'] == true && (aeo['configuration']['YVE_RSQ8'] == false && aeo['configuration']['YTY'] == false)) {
							json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection]['backrestTopRSline']
						} else {
							json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][filteredComponent]
						}
					break;
					case 'biese':
						json.image = ""
						if ((aeo['configuration']['YYA'] == true) || (aeo['configuration']['N0Q'] == true)) {
							json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_'+backSeatModel+'_biese'][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][filteredComponent]
						}
					break;
					case 'embossing':
						json.image = ""
						if ((aeo['configuration']['YTY'] == true) && (carModel != 21)) {
							json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_'+backSeatModel+'_embossing'][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][filteredComponent]
						}
						if ((aeo['configuration']['YTY'] == true) && (carModel == 21)) {							
							json.image = aeo['paths']['backseat_Q4Q_RS_AU53X_embossing_color'][colorCode]
						}
					break; 
					case 'headrestPillow':
						json.image = ""
						if (aeo['configuration']['YXK'] == true) {
							json.image = aeo['paths']['car_backseat_YXK_pillow'][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][filteredComponent]
						}
					break; 
					case 'extraPillow':
					case 'audiRingsStiching':
						json.image = ""
						if ((aeo['configuration']['YXK'] == true) || ((aeo['configuration']['N1V'] == true && $('html').attr('lang') != 'cn'))) {
							json.image = aeo['paths']['car_backseat_YXK_pillow'][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][filteredComponent]
						}
					break;
					case 'headrestFront':
						var q1dembossingBack = (document.querySelector("input[name=q1dembossing]") || {}).value || "";
						var modelCategoryBack = (document.querySelector("input[name=modelcategory]") || {}).value || "";
						var slineHasBackImage = backSeatModel.indexOf('5KI') !== -1;
						var backComponentKey = (q1dembossingBack && modelCategoryBack != 'a8' && slineHasBackImage)
							? 'interior_screen_back'+seatComponentSelection+q1dembossingBack
							: 'interior_screen_back'+seatComponentSelection;
						json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components'][backComponentKey][filteredComponent]
					break;
					default:
						json.image = aeo['paths'][componentType+'_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][filteredComponent]
					break;
				}
			} else {
				json.image = ""
			}
			break;
	
		default:
			break;
	}
	return json;
}

function getInteriorCustomizedComponentImage(unfilteredComponent, colorCode){
	let json = {};
	let imageSourceFront=""
	let imageSourceBack=""
	let component = unfilteredComponent.replace("Color", "");	




	//IF COMPONENT IS INTERIOR ABOVE AND BELOW
	//let isYSIPackage = (aeo['configuration']['YSI'] == true)
	//let isYSI_Q7Q8Package = (aeo['configuration']['YSI_Q7Q8'] == true)
	let isYSJ_Q7Q8Package = (aeo['configuration']['YSJ_Q7Q8'] == true)
	let isYSJA6Package = (aeo['configuration']['YSJ_A6'] == true)
	let isYSJPackage =  (aeo['configuration']['YSJ'] == true)
	let isYSNPackage =  (aeo['configuration']['YSN'] == true)	
	let isQ8H7HHPackage = (aeo['configuration']['Q8H'] == true)
	let isQ8H7HH_A5_Package = (aeo['configuration']['Q8H_A5'] == true)
	let isQ8H_A6etron_Package = (aeo['configuration']['Q8H_A6etron'] == true)
	let isQ8H_A6_C9_Package = (aeo['configuration']['Q8H_A6_C9'] == true)
	let is7HF_A6_C9_Package = (aeo['configuration']['7HF_A6_C9'] == true)
	let isYFB_etronGT_Package = (aeo['configuration']['YFB_etronGT'] == true)
	let isYVJ_etronGT_Package = (aeo['configuration']['YVJ'] == true)
	let is7HH_Q7Q9_Package = (aeo['configuration']['7HH_Q7Q9'] == true)
	let is7HF_Q7Q9_Package = (aeo['configuration']['7HF_Q7Q9'] == true)
	let is0UB_Q7Q9_Package = (aeo['configuration']['0UB_Q7Q9'] == true)

	//let isYVKPackage =  (aeo['configuration']['YVK'] == true)
	let isLeatherPackageYZ1 = (aeo['configuration']['YZ1'] == true || 
			aeo['configuration']['YZ1_Q7Q8'] == true ||  
			aeo['configuration']['YZ1_A8'] == true )
	let isLeatherPackageYS1 = aeo['configuration']['YS1'] == true
	let isLeatherPackageYZ4 = aeo['configuration']['YZ4_A8'] == true
	let isLeatherPackageFC1 = aeo['configuration']['FC1_A6_C9'] == true || aeo['configuration']['FC1_A5'] == true;

	if(isYSJPackage) {
		if (['upperDashboard', 'stitchUpperDashboard', 'instrumentPanelCover',
		'stitchInstrumentPanelCover', 'doorRail', 'stitchDoorRail'].indexOf(component) != -1) {
		imageSourceFront = aeo['paths']['interior_upper_front_view'][colorCode] + aeo['components']['interior_upper'][component]
			if(['doorRail', 'stitchDoorRail'].indexOf(component) != -1) {
			imageSourceBack = aeo['paths']['interior_upper_back_view'][colorCode] + aeo['components']['interior_upper'][component]
			}
		}
	} else if (isYSJA6Package) {		
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		if (['stitchbottomCenterConsole', 'bottomCenterConsole', 'instrumentPanelCover',
				'stitchInstrumentPanelCover', 'doorRail', 'stitchDoorRail', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSJ_A6_front_view'][colorCode]
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest','doorRail', 'stitchDoorRail'].indexOf(component) != -1) {
				imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSJ_A6_back_view'][colorCode]
			}
		}
	/*
} else if (isYVKPackage) {		
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		if (['stitchbottomCenterConsole', 'bottomCenterConsole', 'instrumentPanelCover',
				'stitchInstrumentPanelCover', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YVK_front_view'][colorCode]
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YVK_back_view'][colorCode]
			}
		}	
	*/


	} else if (isYSJ_Q7Q8Package) {	
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		if (['stitchbottomCenterConsole', 'topCenterConsole','bottomCenterConsole', 'instrumentPanelCover',
				'stitchInstrumentPanelCover', 'doorRail', 'stitchDoorRail', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSJ_Q7Q8_front_view'][colorCode]
			if(['topCenterConsole', 'doorArmRest', 'stitchDoorArmRest','doorRail', 'stitchDoorRail'].indexOf(component) != -1) {
				imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSJ_Q7Q8_back_view'][colorCode]
			}
		}	
	/*
} else if (isYSIPackage) {
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (['stitchbottomCenterConsole', 'bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSI_front_view'][colorCode]
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSI_back_view'][colorCode]
			}
		}	
	} else if (isYSI_Q7Q8Package) {
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (['stitchbottomCenterConsole', 'bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_YSI_Q7Q8_front_view'][colorCode]
			if(['bottomCenterConsole', 'doorArmRest', 'stitchDoorArmRest'].indexOf(component) != -1) {
				imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_YSI_Q7Q8_back_view'][colorCode]
			}
		}	
		*/
	} else if (isYSNPackage) {
			if (['instrumentPanelCover', 'stitchInstrumentPanelCover'].indexOf(component) != -1) {
				imageSourceFront = aeo['images'][component + '_YSN_front_view'][colorCode]
		}
	}

	//IF COMPONENT IS BASIC INTERIOR LEATHER
	if (isLeatherPackageYS1) {
		if (['centerArmrest', 'stitchCenterArmrest', 'doorTrimInsert', 'stitchDoorTrimInsert', 'bottomCenterConsole',
		'stitchbottomCenterConsole', 'doorArmRest', 'topCenterConsole', 'stitchDoorArmRest'].indexOf(component) != -1) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			var seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
			if (component != 'topCenterConsole' && aeo['components']['interior_screen_back'+seatComponentSelection][component] != undefined) { //unvalid component
				imageSourceBack = aeo['paths']['car_backseat_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][component]
			} else {
				//*imageSourceBack = ""
			}
			if (aeo['components']['interior_screen_front'+seatComponentSelection][component] != undefined) {
				imageSourceFront = aeo['paths']['car_frontseat_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][component]
			} else {
				//*imageSourceBack = ""
			}
		}
	}

	if (isLeatherPackageYZ1) {
		
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		var modelCategory = document.querySelector("input[name=modelcategory]").value
		var seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
		var n1v = document.querySelector("input[name=n1v]").value
		var componentArray = new Array('centerArmrest', 'stitchCenterArmrest', 'doorTrimInsert')
		// fake - doortriminsert in rhombus START
		if(component == 'doorTrimInsert' || component == 'stitchDoorTrimInsert') {
			if(modelCategory=='a8'){
				if(n1v){
					frontSeatModel = 'Q2J_RAUTE_AU65X'; // fake - only this seatimages has doortriminsert in rhombus
					var n1vArray = ['stitchDoorTrimInsert'];
					componentArray = componentArray.concat(n1vArray);
				} else {
					frontSeatModel = 'Q2J_AU65X'; 
				}
			}
		}
		// fake - doortriminsert in rhombus END
		if (componentArray.indexOf(component) != -1) {
			if (component != 'topCenterConsole' && aeo['components']['interior_screen_back'+seatComponentSelection][component] != undefined) { //unvalid component
				if ((component != 'centerArmrest' && component != 'stitchCenterArmrest') || modelCategory=='a8') {
					imageSourceBack = aeo['paths']['car_backseat_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][component]	
				}
			} else {
				//*imageSourceBack = ""
			}
			if (aeo['components']['interior_screen_front'+seatComponentSelection][component] != undefined) {
				imageSourceFront = aeo['paths']['car_frontseat_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][component]
			} else {
				//*imageSourceBack = ""
			}
		}
	}

	if (isLeatherPackageFC1) {
		
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		var modelCategory = document.querySelector("input[name=modelcategory]").value
		var seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
		var componentArray = new Array('centerArmrest', 'stitchCenterArmrest')
		
		if (componentArray.indexOf(component) != -1) {
			if (component != 'topCenterConsole' && aeo['components']['interior_screen_back'+seatComponentSelection][component] != undefined) { //unvalid component
				/*if (component != 'centerArmrest' && component != 'stitchCenterArmrest') {
					imageSourceBack = aeo['paths']['car_backseat_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][component]	
				}*/
			} else {
				//*imageSourceBack = ""
			}
			if (aeo['components']['interior_screen_front'+seatComponentSelection][component] != undefined) {
				imageSourceFront = aeo['paths']['car_frontseat_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][component]
			} else {
				//*imageSourceBack = ""
			}
		}
	}

	if (isLeatherPackageYZ4) {
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		var modelCategory = document.querySelector("input[name=modelcategory]").value
		var seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
		var n1v = document.querySelector("input[name=n1v]").value
		var componentArray = new Array('centerArmrest', 'stitchCenterArmrest', 'doorTrimInsert', 'bottomCenterConsole',
			'stitchbottomCenterConsole', 'doorArmRest', 'topCenterConsole', 'stitchDoorArmRest',
			'doorRail','stitchDoorRail','instrumentPanelCoverBelow','rockerPanel','instrumentPanelCover','stitchInstrumentPanelCover',
			'doorPanelBelow','stitchDoorPanelBelow')
		// fake - doortriminsert in rhombus START
		if(component == 'doorTrimInsert' || component == 'stitchDoorTrimInsert') {
			if(modelCategory=='a8'){
				if(n1v){
					frontSeatModel = 'Q2J_RAUTE_AU65X'; // fake - only this seatimages has doortriminsert in rhombus
					var n1vArray = ['stitchDoorTrimInsert'];
					componentArray = componentArray.concat(n1vArray);
				} else {
					frontSeatModel = 'Q2J_AU65X'; 
				}
			}
		}
		// fake - doortriminsert in rhombus END
		if (componentArray.indexOf(component) != -1) {
			if (component != 'topCenterConsole' 
			&& component != 'instrumentPanelCover'
			&& aeo['components']['interior_screen_back'+seatComponentSelection][component] != undefined) { //unvalid component
				imageSourceBack = aeo['paths']['car_backseat_'+frontSeatModel+'_'+backSeatModel][colorCode] + aeo['components']['interior_screen_back'+seatComponentSelection][component]
			} else {
				//*imageSourceBack = ""
			}
			if (aeo['components']['interior_screen_front'+seatComponentSelection][component] != undefined) {
				imageSourceFront = aeo['paths']['car_frontseat_'+frontSeatModel][colorCode] + aeo['components']['interior_screen_front'+seatComponentSelection][component]
			} else {
				//*imageSourceBack = ""
			}
		}
	}

	//IF COMPONENT IS DECO WOOD
	if (component == 'decoInlay') {
		let isYTAPackage = aeo['configuration']['YTA'] == true
		let isYTAPackage_Q7Q8 = aeo['configuration']['YTA_Q7Q8'] == true
		let isYTAPackage_A8 = aeo['configuration']['YTA_A8'] == true
		let isYZ4_A8 = aeo['configuration']['YZ4_A8'] === true
		let isA6_C9 = aeo['configuration']['7TZ_A6_C9'] === true || aeo['configuration']['7TN_A6_C9'] === true
		let isA6etron = aeo['configuration']['7TZ_A6etron'] === true
		let isA6etron_7TN = aeo['configuration']['7TN_A6etron'] === true
		let isA5 = aeo['configuration']['7TZ_A5'] === true
		let isA5_7TN = aeo['configuration']['7TN_A5'] === true
        var carModel = document.querySelector("input[name=carmodel]").value;

		if (isYTAPackage) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (colorCode != 8) {
				imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]
				imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]
			}
		}
		if (isYTAPackage_Q7Q8) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (colorCode != 8) {
				imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]
				imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]
			}
			if ((carModel == 21)) {
				// RSQ8 
				imageSourceFront = aeo['images']['decoInlay_rsq8_' + frontSeatModel + '_front_view'][colorCode]		
				imageSourceBack = aeo['images']['decoInlay_rsq8_' + backSeatModel + '_back_view'][colorCode]
				// RSQ8 
			}
		}
		if (isYTAPackage_A8) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (colorCode != 8) {
				imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]
				imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]
				
                /*
				if (!isYZ4_A8 && (carModel > 21) && (carModel < 28)) {
                    // only A8/A8 L, not YZ4: doorarmrest-deco 
                    imageSourceFront = aeo['images']['decoInlay_tuerarmauflage_' + frontSeatModel + '_front_view'][colorCode]        
                    imageSourceBack = aeo['images']['decoInlay_tuerarmauflage_' + backSeatModel + '_back_view'][colorCode]
                    // only A8/A8 L, not YZ4: doorarmrest-deco
                }
				*/
				

				if ((carModel == 23) || (carModel == 25) || (carModel == 26) || (carModel == 27)) {
					// A8 S line, A8 L S line, S8, S8 L: doorarmrest-deco 
					imageSourceFront = aeo['images']['decoInlay_tuerarmauflage_' + frontSeatModel + '_front_view'][colorCode]		
					imageSourceBack = aeo['images']['decoInlay_tuerarmauflage_' + backSeatModel + '_back_view'][colorCode]
					// A8 S line, A8 L S line, S8, S8 L: doorarmrest-deco 
				}	
			
				if (isYZ4_A8 && ((carModel == 22) || (carModel == 24))) {
					// only A8/A8 L, with YZ4: doorarmrest-deco 
					imageSourceFront = aeo['images']['decoInlay_tuerarmauflage_' + frontSeatModel + '_front_view'][colorCode]		
					imageSourceBack = aeo['images']['decoInlay_tuerarmauflage_' + backSeatModel + '_back_view'][colorCode]
					// only A8/A8 L, with YZ4: doorarmrest-deco 
				}

                
			}
		}

		if (isA6_C9) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (colorCode != 8) {
				imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]
				imageSourceBack = aeo['images']['decoInlay_' + frontSeatModel + '_' + backSeatModel + '_back_view'][colorCode]               
			}
		}

		if ((isA6etron) || (isA6etron_7TN)) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (colorCode != 8) {
				imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]
				imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]               
			}
		}

		if ((isA5) || (isA5_7TN)) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			if (colorCode != 8) {
				imageSourceFront = aeo['images']['decoInlay_' + frontSeatModel + '_front_view'][colorCode]
				imageSourceBack = aeo['images']['decoInlay_' + backSeatModel + '_back_view'][colorCode]               
			}
		}

		
	}

	//IF COMPONENT IS SKY
	/*
	if (component == 'sky') {
		let isYXPPackage = aeo['configuration']['YXP'] == true
		if (isYXPPackage) {

			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			//if (colorCode != 8) {
				imageSourceFront = aeo['images']['sky_' + frontSeatModel + '_front_view'][colorCode]
				imageSourceBack = aeo['images']['sky_' + backSeatModel + '_back_view'][colorCode]
			//}
		}
	}
	*/



	//IF COMPONENT IS BASIC INTERIOR STITCH
	if (component == 'interiorStitch') {
		let isStitchPackage = aeo['configuration']['YVJ'] == true
		if (isStitchPackage) {
			let isHourMarkSteeringWheel = aeo['configuration']['YVN'] == true || aeo['configuration']['YVN_without12h'] == true;
			imageSourceFront = aeo['images'][isHourMarkSteeringWheel ? 'twelve_mark_interior_stitch_front' : 'interior_stitch_front'][colorCode]
			imageSourceBack = aeo['images']['interior_stitch_back'][colorCode]
		}
	}

	//IF COMPONENT IS BICOLOR
	if (component == 'bicolor') {
		var carModel = document.querySelector("input[name=carmodel]").value;
		let isYVEPackage = aeo['configuration']['YVE'] == true
		let isYVEPackageRS6RS7 = aeo['configuration']['YVE_RS6RS7'] == true
		let isYVEPackageRSQ8 = aeo['configuration']['YVE_RSQ8'] == true
		let isYN1Package = aeo['configuration']['YN1'] == true
		let isYN2Package = aeo['configuration']['YN2'] == true
		let isYN1_A5Package = aeo['configuration']['YN1_A5'] == true
		let isYN2_A5Package = aeo['configuration']['YN2_A5'] == true
		let isYN3_A5Package = aeo['configuration']['YN3_A5'] == true
		let isYN4_A5Package = aeo['configuration']['YN4_A5'] == true
		let isYN1_A6etron = aeo['configuration']['YN1_A6etron'] == true
		let isYN2_A6etron = aeo['configuration']['YN2_A6etron'] == true
		let isYN1_A6_C9 = aeo['configuration']['YN1_A6_C9'] == true
		let isYN2_A6_C9 = aeo['configuration']['YN2_A6_C9'] == true
		let isYN1_Q7Q9 = aeo['configuration']['YN1_Q7Q9'] == true
		let isYN2_Q7Q9 = aeo['configuration']['YN2_Q7Q9'] == true
		let isYN3_SQ6_perf = aeo['configuration']['YN3_SQ6_perf'] == true
		let isYN4_SQ6_perf = aeo['configuration']['YN4_SQ6_perf'] == true
		if (isYVEPackage) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]

			if ((carModel == 2) || (carModel == 200)/* || (carModel == 14)*/) {
				// only etron RS, RS6, RS7
				imageSourceFront = aeo['images']['bicolor_rs_' + frontSeatModel + '_front_view'][colorCode]	
				// only etron RS, RS6, RS7 
			}
		}
		if (isYVEPackageRS6RS7) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value			
			imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_rs6rs7_' + backSeatModel + '_back_view'][colorCode]
		}
		if (isYVEPackageRSQ8) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value
			var steering_wheel = document.querySelector("input[name=steering-wheel-model]").value;
			
			if (steering_wheel == 21) {
				imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view_sportkontur'][colorCode]	
			}	
			if (steering_wheel == 22) {
				imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view_sportlenkrad'][colorCode]	
			}			
			//imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_rsq8_' + backSeatModel + '_back_view'][colorCode]
		}
		if (isYN1Package) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value			
			imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
		}
		if (isYN2Package) {
			var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
			var backSeatModel = document.querySelector("input[name=backseatmodel]").value			
			imageSourceFront = aeo['images']['bicolor_' + frontSeatModel + '_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
		}
		if (isYN1_A5Package) {		
			imageSourceFront = aeo['images']['bicolor_Q1D_AU401_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A5_N3M_back_view'][colorCode]
		}
		if (isYN2_A5Package) {		
			imageSourceFront = aeo['images']['bicolor_Q4Q_AU401_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A5_Q4Q_N3M_back_view'][colorCode]
		}
		if (isYN3_A5Package) {		
			imageSourceFront = aeo['images']['bicolor_Q4Q_AU401_YN3_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A5_Q4Q_N3M_YN3_back_view'][colorCode]
		}
		if (isYN4_A5Package) {		
			imageSourceFront = aeo['images']['bicolor_Q4Q_AU401_YN4_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A5_Q4Q_N3M_YN4_back_view'][colorCode]
		}
		if (isYN1_A6etron) {		
			imageSourceFront = aeo['images']['bicolor_Q1D_AU513_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A6_etron_N2S_back_view'][colorCode]
		}
		if (isYN2_A6etron) {		
			imageSourceFront = aeo['images']['bicolor_Q4Q_AU513_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A6_etron_Q4Q_N3M_back_view'][colorCode]
		}	
		if (isYN1_A6_C9) {		
			imageSourceFront = aeo['images']['bicolor_Q1D_AU592_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A6_C9_N2S_back_view'][colorCode]
		}
		if (isYN2_A6_C9) {		
			imageSourceFront = aeo['images']['bicolor_Q4Q_AU592_front_view'][colorCode]
			imageSourceBack = aeo['images']['bicolor_A6_C9_Q4Q_N3M_back_view'][colorCode]
		}		

		backSeatModel = document.querySelector("input[name=backseatmodel]").value	

		/* Q7/Q9 steering wheel check */
		var steering_wheel = document.querySelector("input[name=steering-wheel-model]").value;
		var sw_abbr = "2zq";
		if ((steering_wheel == 104)) { sw_abbr = "2zq"; }
		if ((steering_wheel == 105)) { sw_abbr = "2fs"; }
		if ((steering_wheel == 106)) { sw_abbr = "1xy"; }
		/* Q7/Q9 steering wheel check */

		if ((carModel == 115)) {
				if (isYN1_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]	
					imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
				}
				if (isYN2_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_back_view'][colorCode]
				}
				
			}
		if ((carModel == 116) || (carModel == 117)) {
				if (isYN1_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_back_view'][colorCode]
				}
				if (isYN2_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_back_view'][colorCode]
				}

			}
		
		if ((carModel == 118)) {
				if (isYN1_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]	
					imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_Q9_back_view'][colorCode]
				}
				if (isYN2_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_Q9_back_view'][colorCode]
				}
				
			}

		if ((carModel == 119) || (carModel == 120)) {
				if (isYN1_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q1D_AU546_' + sw_abbr + '_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_' + backSeatModel + '_Q9_back_view'][colorCode]
				}
				if (isYN2_Q7Q9) {
					imageSourceFront = aeo['images']['bicolor_Q4Q_AU546_' + sw_abbr + '_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_yn2_' + backSeatModel + '_Q9_back_view'][colorCode]
				}

			}
		if ((carModel == 70) || (carModel == 71)) {
				if (isYN3_SQ6_perf) {
					imageSourceFront = aeo['images']['bicolor_YN3_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_YN3_back_view'][colorCode]
				}
				if (isYN4_SQ6_perf) {
					imageSourceFront = aeo['images']['bicolor_YN4_front_view'][colorCode]
					imageSourceBack = aeo['images']['bicolor_YN4_back_view'][colorCode]
				}
				
			}
	}

	if (isQ8H7HHPackage) {			
		var carModel = document.querySelector("input[name=carmodel]").value
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		var componentArray = new Array('centerArmrest', 'doorTrimInsert', 'stitchDoorArmRest', 'softwrap',
		'stitchSoftwrap', 'bottomCenterConsole', 'stitchInstrumentPanelCover')

		if (carModel == 70 || carModel == 71) { // SQ6 etron performance
			if (componentArray.indexOf(component) != -1) {
				imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_SQ6_PERF_'+component+'_front_view'][colorCode]
				if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert')) {
					imageSourceBack = aeo['images']['car_backseat_'+frontSeatModel+'_'+backSeatModel+'_Q8H_SQ6_PERF_'+component+'_back_view'][colorCode]
				}

			}
		} else {
			if (componentArray.indexOf(component) != -1) {
				imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_'+component+'_front_view'][colorCode]
				if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert')) {
					imageSourceBack = aeo['images']['car_backseat_'+frontSeatModel+'_'+backSeatModel+'_Q8H_7HH_'+component+'_back_view'][colorCode]
				}

			}
		}
	}

	if (isQ8H_A6etron_Package) {			
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value

		var componentArray = new Array('centerArmrest', 'doorTrimInsert', 'stitchDoorArmRest', 'softwrap',
		'stitchSoftwrap', 'bottomCenterConsole', 'stitchInstrumentPanelCover')

		if (componentArray.indexOf(component) != -1) {
			imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_'+component+'_front_view'][colorCode]
			if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert')) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_'+component+'_back_view'][colorCode]
			}

		}
	}

	if (isQ8H7HH_A5_Package) {					
        var carModel = document.querySelector("input[name=carmodel]").value;
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value

		var componentArray = new Array('doorTrimInsert', 'stitchDoorArmRest', 'softwrap',
		'bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover')

		if (componentArray.indexOf(component) != -1) {
			if ((carModel == 46) || (carModel == 47)) {
				imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_RS5_'+component+'_front_view'][colorCode]
				if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'stitchInstrumentPanelCover')) {
					imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_RS5_'+component+'_back_view'][colorCode]
				}
			} else {
				imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_A5_'+component+'_front_view'][colorCode]
				if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'stitchInstrumentPanelCover')) {
					imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_A5_'+component+'_back_view'][colorCode]
				}
			} 

		}
	}

	if (is7HH_Q7Q9_Package) {					
        var carModel = document.querySelector("input[name=carmodel]").value;
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value

		var componentArray = new Array('doorArmRest', 'stitchDoorArmRest','bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover', 'stitchCenterArmrest','centerArmrest','rearCenterArmrestInterior')

		if (componentArray.indexOf(component) != -1) {
				imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_7HH_Q7Q9_'+component+'_front_view'][colorCode]
				if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'stitchInstrumentPanelCover') || (component == 'rearCenterArmrestInterior') || (component == 'stitchbottomCenterConsole') || (component == 'bottomCenterConsole')) {
					imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HH_Q7Q9_'+component+'_back_view'][colorCode]
				}
				
				if ((carModel == 118) || (carModel == 119) || (carModel == 120)) {
					if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'rearCenterArmrestInterior') || (component == 'stitchInstrumentPanelCover') || (component == 'bottomCenterConsole') || (component == 'stitchbottomCenterConsole')) {
						imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HH_Q9_'+component+'_back_view'][colorCode]
					}
				}

		}
	}

	if (is7HF_Q7Q9_Package) {
        var carModel = document.querySelector("input[name=carmodel]").value;
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value

		var componentArray = new Array('doorArmRest', 'stitchDoorArmRest','bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover', 'instrumentPanelCover', 'stitchCenterArmrest','centerArmrest','rearCenterArmrestInterior')

		if (componentArray.indexOf(component) != -1) {
				imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_7HF_Q7Q9_'+component+'_front_view'][colorCode]
				if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'stitchInstrumentPanelCover') || (component == 'instrumentPanelCover') || (component == 'rearCenterArmrestInterior') || (component == 'stitchbottomCenterConsole') || (component == 'bottomCenterConsole')) {
					imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HF_Q7Q9_'+component+'_back_view'][colorCode]
				}
				
				if ((carModel == 118) || (carModel == 119) || (carModel == 120)) {
					if ((component == 'stitchDoorArmRest') || (component == 'doorArmRest') || (component == 'stitchInstrumentPanelCover') || (component == 'instrumentPanelCover') || (component == 'rearCenterArmrestInterior') || (component == 'stitchbottomCenterConsole') || (component == 'bottomCenterConsole')) {
						imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HF_Q9_'+component+'_back_view'][colorCode]
					}

				}
	}
}


	if (is0UB_Q7Q9_Package) {
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value
		var carModelQ7Q9 = document.getElementsByName("carmodel")[0].value;
		var componentArray = new Array('doorTrimInsert')

		if (componentArray.indexOf(component) != -1) {
			imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_0UB_Q7Q9_'+component+'_front_view'][colorCode]
			imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_0UB_Q7Q9_'+component+'_back_view'][colorCode]
			if (carModelQ7Q9 == '118' || carModelQ7Q9 == '119' || carModelQ7Q9 == '120') {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_0UB_Q9_'+component+'_back_view'][colorCode]
			}
		}
	}


	
	if (isQ8H_A6_C9_Package) {			
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value

		//var componentArray = new Array('doorTrimInsert', 'doorArmRest', 'stitchDoorArmRest', 'softwrap',
			//'bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover')
		var componentArray = new Array('doorTrimInsert', 'stitchDoorArmRest', 'softwrap',
			'bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover')

		if (componentArray.indexOf(component) != -1) {
			imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_Q8H_7HH_A6_C9_'+component+'_front_view'][colorCode]
			if ((component == 'doorArmRest') || (component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'instrumentPanelCover') || (component == 'stitchInstrumentPanelCover') || (component == 'softwrap')) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_Q8H_7HH_A6_C9_'+component+'_back_view'][colorCode]
			}

		}
	}	

	if (is7HF_A6_C9_Package) {			
		var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
		var backSeatModel = document.querySelector("input[name=backseatmodel]").value

		var componentArray = new Array('doorTrimInsert', 'stitchDoorArmRest', 'softwrap',
			'bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover', 'instrumentPanelCover')
		//var componentArray = new Array('doorTrimInsert', 'doorArmRest', 'stitchDoorArmRest', 'softwrap',
			//'bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover', 'instrumentPanelCover')
		//var componentArray = new Array('doorTrimInsert', 'stitchDoorArmRest', 'softwrap',
			//'bottomCenterConsole', 'stitchbottomCenterConsole', 'stitchInstrumentPanelCover')
			
		if (componentArray.indexOf(component) != -1) {
			imageSourceFront = aeo['images']['car_frontseat_'+frontSeatModel+'_7HF_A6_C9_'+component+'_front_view'][colorCode]	
			if ((component == 'stitchDoorArmRest') || (component == 'doorTrimInsert') || (component == 'instrumentPanelCover')  || (component == 'stitchInstrumentPanelCover') || (component == 'softwrap')) {
				imageSourceBack = aeo['images']['car_backseat_'+backSeatModel+'_7HF_A6_C9_'+component+'_back_view'][colorCode]
			}

		}
	}	
	


//Footmat Components

	
	let isYTUpackage = aeo['configuration']['YTU'] == true
	let isYSQPackage = aeo['configuration']['YSQ'] == true
	let isYSRPackage = aeo['configuration']['YSR'] == true
	let isYSRA6Package = aeo['configuration']['YSR_A6'] == true
	let isYTU_RS6RS7Package = aeo['configuration']['YTU_RS6RS7'] == true
	let isYSRQ7Q8Package = aeo['configuration']['YSR_Q7Q8'] == true
	let isYSQQ7Q8Package = aeo['configuration']['YSQ_Q7Q8'] == true
	let isYTUQ7Q8Package = aeo['configuration']['YTU_Q7Q8'] == true
	let isYSRA8Package = aeo['configuration']['YSR_A8'] == true
	let set0TF_Q6etron = aeo['configuration']['0TF'] == true
	let set0TF_A5 = aeo['configuration']['0TF_A5'] == true
	let set0TF_A6etron = aeo['configuration']['0TF_A6etron'] === true
	let set0TF_A6_C9 = aeo['configuration']['0TF_A6_C9'] === true
	let set0TF_Q7_Q9 = aeo['configuration']['0TF_Q7Q9'] === true
	


	//Footmat Components e-tron and A6/A7 START
	if ((document.getElementsByName("carmodel")[0].value <= 2) || (document.getElementsByName("carmodel")[0].value == 200) || (document.getElementsByName("carmodel")[0].value == 201)) { 
		if (component ==  "piping") {
			imageSourceFront = aeo['images']['piping_front_view'][colorCode]
			imageSourceBack = aeo['images']['piping_back_view'][colorCode]
		}
		if (component ==  "stitchPiping") {
			imageSourceFront = aeo['images']['stitch_piping_front_view'][colorCode]
			imageSourceBack = aeo['images']['stitch_piping_back_view'][colorCode]
		}
		
		if (component ==  "footmatEmbossing") {
			if (isYTUpackage == true) {
				if ((document.getElementsByName("carmodel")[0].value == 2) || (document.getElementsByName("carmodel")[0].value == 200)) imageSourceFront = aeo['images']['footmatEmbossing_YTU_front_view'][colorCode]
			}
		}
		
	} else {
		
		if (document.getElementsByName('frontseatmodel')[0]  != null ) {
			
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q1D') { 					
				if (isYSRA6Package == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q1D_YSR_A6_front_view'][colorCode]
					}
				}					
				if (isYTU_RS6RS7Package == true) {  /// Pfad prüfen!!!!
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "footmatEmbossing")) {
						imageSourceFront = aeo['images'][component + '_Q1D_YSR_A6_front_view'][colorCode]
					}
				}					
				if (isYSQPackage == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
						imageSourceFront = aeo['images'][component + '_Q1D_YSQ_front_view'][colorCode]
					}
				}
			}

			if (document.getElementsByName("frontseatmodel")[0].value == 'Q2J') { 	
				
				if (isYSRA6Package == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q2J_YSR_A6_front_view'][colorCode]
					}
					
				}					
				if (isYTU_RS6RS7Package == true) { 
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "footmatEmbossing")) {
						imageSourceFront = aeo['images'][component + '_Q2J_YSR_A6_front_view'][colorCode]
					}
				}	
				
				if (isYSQPackage == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
						imageSourceFront = aeo['images'][component + '_Q2J_YSQ_front_view'][colorCode]
					}
				}	

			}

		
			//Q7/Q8

			var front_seat_modell = document.getElementsByName("frontseatmodel")[0].value;
			//if (document.getElementsByName("frontseatmodel")[0].value == 'Q2J_AU53X') { 	
				
				if (isYSRQ7Q8Package == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_' + front_seat_modell + '_YSR_Q7Q8_front_view'][colorCode]
					}
					
				}

				if (isYSQQ7Q8Package == true) { 
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
						imageSourceFront = aeo['images'][component + '_' + front_seat_modell + '_YSQ_Q7Q8_front_view'][colorCode]
						}
					
				}	

				if (isYTUQ7Q8Package == true) { 
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese") || (component ==  "footmatEmbossing")) {
						imageSourceFront = aeo['images'][component + '_' + front_seat_modell + '_YTU_Q7Q8_front_view'][colorCode]
					}
				}	
			//}
			//Q7/Q8

			//A8
			var front_seat_modell = document.getElementsByName("frontseatmodel")[0].value;	
			
			if (isYSRA8Package == true) {
				if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
					imageSourceFront = aeo['images'][component + '_' + front_seat_modell + '_YSR_A8_front_view'][colorCode]
				}
				
			}
			//A8

			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q') { 						
				if (isYSRA6Package == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_YSR_A6_front_view'][colorCode]
					}
				}				
				if (isYTU_RS6RS7Package == true) { 
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "footmatEmbossing")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_YSR_A6_front_view'][colorCode]
					}
				}	
				
				if (isYSQPackage == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_YSQ_front_view'][colorCode]
					}
				}			
			}
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_RS') { 						
				if (isYSRA6Package == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_RS_YSR_A6_front_view'][colorCode]
					}
				}			
				if (isYTU_RS6RS7Package == true) { 
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "footmatEmbossing")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_RS_YSR_A6_front_view'][colorCode]
					}
				}	
				
				if (isYSQPackage == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_RS_YSQ_front_view'][colorCode]
					}
				}	
			}



			// backseatmodel				
			if (document.getElementsByName("backseatmodel")[0].value == '3NZ') { 
				if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
					imageSourceBack = aeo['images'][component + '_3NZ_back_view'][colorCode]
				}
			}				
			if (document.getElementsByName("backseatmodel")[0].value == '3NT') {  
				if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
					imageSourceBack = aeo['images'][component + '_3NT_back_view'][colorCode]
				}
			}

			// Q7/Q8
			if (document.getElementsByName("backseatmodel")[0].value == '5KA') { 				
				if (isYSRQ7Q8Package == true) { // wenn okay und alle Sitze definiert, übertragen auf andere Sitze
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_5KA_YSR_Q7Q8_back_view'][colorCode]
					}
					
				}
				if (isYSQQ7Q8Package == true) { // wenn okay und alle Sitze definiert, übertragen auf andere Sitze
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
						imageSourceBack = aeo['images'][component + '_5KA_YSQ_Q7Q8_back_view'][colorCode]
					}
					
				}	
				if (isYTUQ7Q8Package == true) { 
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_5KA_YTU_Q7Q8_back_view'][colorCode]
					}
				}	
			}

			// A8
			if (document.getElementsByName("backseatmodel")[0].value == '5KF') { 				
				if (isYSRA8Package == true) { // wenn okay und alle Sitze definiert, übertragen auf andere Sitze
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_5KF_YSR_A8_back_view'][colorCode]
					}
					
				}	
			}


			if (document.getElementsByName("backseatmodel")[0].value == '3NS') { 				
				if (isYSRQ7Q8Package == true) { // wenn okay und alle Sitze definiert, übertragen auf andere Sitze
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_3NS_YSR_Q7Q8_back_view'][colorCode]
					}
					
				}
				if (isYSQQ7Q8Package == true) { // wenn okay und alle Sitze definiert, übertragen auf andere Sitze
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmat") || (component ==  "footmatBiese") || (component ==  "carpet")) {
						imageSourceBack = aeo['images'][component + '_3NS_YSQ_Q7Q8_back_view'][colorCode]
					}
					
				}	
				if (isYTUQ7Q8Package == true) { 
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_3NS_YTU_Q7Q8_back_view'][colorCode]
					}
				}

			}
			
			// Q6 etron			
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q1A') { 						
				if (set0TF_Q6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping")) {
						imageSourceFront = aeo['images'][component + '_Q1A_0TF_front_view'][colorCode]
					}
				}				
			}	
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_AU41X') { 						
				if (set0TF_Q6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_0TF_front_view'][colorCode]
					}
				}				
			}
			if (document.getElementsByName("backseatmodel")[0].value == 'N15') { 						
				if (set0TF_Q6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping")) {
						imageSourceBack = aeo['images'][component + '_N15_0TF_back_view'][colorCode]
					}
				}				
			}
			if (document.getElementsByName("backseatmodel")[0].value == 'N3M') { 						
				if (set0TF_Q6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping")) {
						imageSourceBack = aeo['images'][component + '_N3M_0TF_back_view'][colorCode]
					}
				}
			}
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_AU41X_PERF') { // SQ6 etron Performance
				if (set0TF_Q6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatEmbossing")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_AU41X_PERF_0TF_front_view'][colorCode]
					}
					if ((component ==  "piping") || (component ==  "stitchPiping")) {
						imageSourceBack = aeo['images'][component + '_Q4Q_AU41X_PERF_N3M_0TF_back_view'][colorCode]
					}
				}
			}
			// Q6 etron

			
			// A5			
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q1D_AU401') { 						
				if (set0TF_A5 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q1D_AU401_0TF_A5_front_view'][colorCode]
					}
				}				
			}	
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_AU401') {
				if (set0TF_A5 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_AU401_0TF_A5_front_view'][colorCode]
					}
				}
			}
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_AU401_RS') {
				if (set0TF_A5 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_AU401_RS_0TF_A5_RS5_front_view'][colorCode]
					}
					if ((component ==  "footmatEmbossing")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_AU401_RS_0TF_A5_RS5_front_view'][colorCode]
					}
				}
			}
			if (document.getElementsByName("backseatmodel")[0].value == 'N2S') {
				if (set0TF_A5 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_N2S_0TF_A5_back_view'][colorCode]
					}
				}
			}
			if (document.getElementsByName("backseatmodel")[0].value == 'N3M') {
				if (set0TF_A5 == true) {
					var carModel0TF = document.getElementsByName("carmodel")[0].value;
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						if (carModel0TF == '46' || carModel0TF == '47') {
							imageSourceBack = aeo['images'][component + '_N3M_0TF_A5_RS5_back_view'][colorCode]
						} else {
							imageSourceBack = aeo['images'][component + '_N3M_0TF_A5_back_view'][colorCode]
						}
					}
				}
			}
			// A5	

			// A6 e-tron			
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q1D_AU513') { 						
				if (set0TF_A6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q1D_AU513_0TF_A6_etron_front_view'][colorCode]
					}
				}				
			}	
			if (document.getElementsByName("backseatmodel")[0].value == 'N1X') { 						
				if (set0TF_A6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_N1X_0TF_A6_etron_back_view'][colorCode]
					}
				}				
			}		
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_AU513') { 						
				if (set0TF_A6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_AU513_0TF_A6_etron_front_view'][colorCode]
					}
				}				
			}	
			if (document.getElementsByName("backseatmodel")[0].value == 'N3M') { 						
				if (set0TF_A6etron == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_N3M_0TF_A6_etron_back_view'][colorCode]
					}
				}				
			}
			// A6 e-tron	

			// A7 C9			
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q1D_AU592') { 						
				if (set0TF_A6_C9 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q1D_AU592_0TF_A6_C9_front_view'][colorCode]
					}
				}				
			}	
			if (document.getElementsByName("backseatmodel")[0].value == 'N2S') { 						
				if (set0TF_A6_C9 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_N2S_0TF_A6_C9_back_view'][colorCode]
					}
				}				
			}		
			if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_AU592') { 						
				if (set0TF_A6_C9 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceFront = aeo['images'][component + '_Q4Q_AU592_0TF_A6_C9_front_view'][colorCode]
					}
				}				
			}	
			if (document.getElementsByName("backseatmodel")[0].value == 'N3M') { 						
				if (set0TF_A6_C9 == true) {
					if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
						imageSourceBack = aeo['images'][component + '_N3M_0TF_A6_C9_back_view'][colorCode]
					}
				}				
			}
			// A7 C9

			// Q7 Q9
			if (set0TF_Q7_Q9 == true) {
				var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
				var backSeatModel = document.querySelector("input[name=backseatmodel]").value
				var carModel = document.querySelector("input[name=carmodel]").value

				if ((component ==  "piping") || (component ==  "stitchPiping") || (component ==  "footmatBiese")) {
					imageSourceFront = aeo['images'][component + '_' + frontSeatModel + '_0TF_Q7Q9_front_view'][colorCode]
					imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_Q7Q9_back_view'][colorCode]
					if (carModel == 118 || carModel == 119 || carModel == 120) {
						imageSourceBack = aeo['images'][component + '_' + backSeatModel + '_0TF_Q9_back_view'][colorCode]
					}
				}
			}
			// Q7 Q9	
			
			
			

		}
	}

//Footmat Components e-tron and A6/A7  END

switch (component) {

		//SeatbeltFull
		case "seatbeltFull": 

		//Seatbelt
		case "seatbelt": 
			let isYTOPackage = ((aeo['configuration']['YTO'] == true) && (component == 'seatbeltFull'))
			let isYTQPackage = aeo['configuration']['YTQ'] == true
			let isYTQA6Package = aeo['configuration']['YTQ_A6'] == true
			let isYTO_Q7Q8Package = ((aeo['configuration']['YTO_Q7Q8'] == true) && (component == 'seatbeltFull'))
			let isYTO_A8Package = ((aeo['configuration']['YTO_A8'] == true) && (component == 'seatbeltFull'))
			let isYTQ_Q7Q8Package = aeo['configuration']['YTQ_Q7Q8'] == true
			let isFZ9Package = aeo['configuration']['FZ9'] == true
			let isFZ8_A5Package = ((aeo['configuration']['FZ8_A5'] == true) && (component == 'seatbeltFull'))
			let isFZ9_A5Package = aeo['configuration']['FZ9_A5'] == true
			let isFZ8_A6etronPackage = ((aeo['configuration']['FZ8_A6etron'] == true) && (component == 'seatbeltFull'))
			let isFZ9_A6etronPackage = aeo['configuration']['FZ9_A6etron'] == true
			let isFZ8_A6_C9_Package = ((aeo['configuration']['FZ8_A6_C9'] == true) && (component == 'seatbeltFull'))
			let isFZ9_A6_C9_Package = aeo['configuration']['FZ9_A6_C9'] == true
			let isFZ8_Q7_Q9_Package = ((aeo['configuration']['FZ8_Q7Q9'] == true) && (component == 'seatbeltFull'))
			let isFZ9_Q7_Q9_Package = aeo['configuration']['FZ9_Q7Q9'] == true

			if ((document.getElementsByName("carmodel")[0].value <= 2) || (document.getElementsByName("carmodel")[0].value == 200) || (document.getElementsByName("carmodel")[0].value == 201)) { 
				imageSourceFront = aeo['images']['seatbelt_Q1J_etron_front_view'][colorCode]
				imageSourceBack = aeo['images']['seatbelt_3NT_etron_back_view'][colorCode]
			} else {
				// frontseatmodel
			
				if (typeof document.getElementsByName("frontseatmodel") !== 'undefined') {

					var front_seat_modell = document.getElementsByName("frontseatmodel")[0].value;
					var back_seat_modell = document.getElementsByName("backseatmodel")[0].value;
					
					if (document.getElementsByName("frontseatmodel")[0].value == 'Q2J') { 
						if (isYTOPackage == true) {
							imageSourceFront = aeo['images']['seatbelt_Q2J_YTO_front_view'][colorCode]
						}
						if (isYTQA6Package == true) {
							imageSourceFront = aeo['images']['seatbelt_Q2J_YTQ_A6_front_view'][colorCode]
						}
					}
					// Q7 Q8
					if (isYTO_Q7Q8Package == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_YTO_Q7Q8_front_view'][colorCode]
					}
					if (isYTQ_Q7Q8Package == true) {							
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_YTQ_Q7Q8_front_view'][colorCode]
					}
				
					// Q7 Q8

					// A8
					if (isYTO_A8Package == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_YTO_A8_front_view'][colorCode]
					}
					// A8
					

					if (document.getElementsByName("frontseatmodel")[0].value == 'Q1D') { 
						
						if (isYTOPackage == true) {
							imageSourceFront = aeo['images']['seatbelt_Q1D_YTO_front_view'][colorCode]
						}
						if (isYTQA6Package == true) {
							imageSourceFront = aeo['images']['seatbelt_Q1D_YTQ_A6_front_view'][colorCode]
						}
					}
					if (document.getElementsByName("frontseatmodel")[0].value == 'Q1J') { 
						if (isYTOPackage == true) {
							imageSourceFront = aeo['images']['seatbelt_Q1J_YTO_front_view'][colorCode]
						}
						if (isYTQA6Package == true) {
							imageSourceFront = aeo['images']['seatbelt_Q1J_YTQ_A6_front_view'][colorCode]
						}

						
					}
					if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q') { 
						if (isYTOPackage == true) {
							imageSourceFront = aeo['images']['seatbelt_Q4Q_YTO_front_view'][colorCode]
						}
						if (isYTQA6Package == true) {
							imageSourceFront = aeo['images']['seatbelt_Q4Q_YTQ_A6_front_view'][colorCode]
						}
					}
					if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_RS') { 
						if (isYTOPackage == true) {
							imageSourceFront = aeo['images']['seatbelt_Q4Q_RS_YTO_front_view'][colorCode]
						}
						if (isYTQA6Package == true) {
							imageSourceFront = aeo['images']['seatbelt_Q4Q_RS_YTQ_A6_front_view'][colorCode]
						}
					}
					// backseatmodel				
					if (document.getElementsByName("backseatmodel")[0].value == '3NZ') { 						
						if (isYTOPackage == true) {							
							if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_RS') { 
								imageSourceBack = aeo['images']['seatbelt_3NZ_YTO_RS_back_view'][colorCode]
							} else {
								imageSourceBack = aeo['images']['seatbelt_3NZ_YTO_back_view'][colorCode]
							}
						}
						if (isYTQA6Package == true) {
							imageSourceBack = aeo['images']['seatbelt_3NZ_YTQ_A6_back_view'][colorCode]
						}
						
					}				
					if (document.getElementsByName("backseatmodel")[0].value == '3NT') { 
						
						if (isYTOPackage == true) {
							if ((document.getElementsByName("frontseatmodel")[0].value == 'Q4Q_RS') || (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q')) { 
								imageSourceBack = aeo['images']['seatbelt_3NT_YTO_RS_back_view'][colorCode]
							} else if (document.getElementsByName("frontseatmodel")[0].value == 'Q4Q') { 
								imageSourceBack = aeo['images']['seatbelt_3NT_YTO_Q4Q_back_view'][colorCode]
							} else {
								imageSourceBack = aeo['images']['seatbelt_3NT_YTO_back_view'][colorCode]
							}
						}
						if (isYTQA6Package == true) {
							imageSourceBack = aeo['images']['seatbelt_3NT_YTQ_A6_back_view'][colorCode]
						}
					}			
					if (document.getElementsByName("backseatmodel")[0].value == '5KA') { 
						
						if (isYTO_Q7Q8Package == true) {
							imageSourceBack = aeo['images']['seatbelt_5KA_YTO_Q7Q8_back_view'][colorCode]
						}
					}		
					if (document.getElementsByName("backseatmodel")[0].value == '3NS') { 						

						if (isYTQ_Q7Q8Package == true) {
							imageSourceBack = aeo['images']['seatbelt_3NS_YTQ_Q7Q8_back_view'][colorCode]
						}
						
						if (isYTO_Q7Q8Package == true) {							
							imageSourceBack = aeo['images']['seatbelt_3NS_YTO_Q7Q8_back_view'][colorCode]
						}
					}
							
					if (document.getElementsByName("backseatmodel")[0].value == '5KF') { 
						
						if (isYTO_A8Package == true) {
							imageSourceBack = aeo['images']['seatbelt_5KF_YTO_A8_back_view'][colorCode]
						}
					}

					// A5
					var carModelSeatbelt = document.getElementsByName("carmodel")[0].value;
					if (isFZ8_A5Package == true) {
						if (carModelSeatbelt == 46 || carModelSeatbelt == 47) {
							imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ8_A5_RS5_front_view'][colorCode]
							imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ8_A5_RS5_back_view'][colorCode]
						} else {
							imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ8_A5_front_view'][colorCode]
							imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ8_A5_back_view'][colorCode]
						}
					}
					if (isFZ9_A5Package == true) {
						if (carModelSeatbelt == 46 || carModelSeatbelt == 47) {
							imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ9_A5_RS5_front_view'][colorCode]
							imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ9_A5_RS5_back_view'][colorCode]
						} else {
							imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ9_A5_front_view'][colorCode]
							imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ9_A5_back_view'][colorCode]
						}
					}
					// A5

					// A6 etron
					if (isFZ8_A6etronPackage == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ8_A6etron_front_view'][colorCode]
						imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ8_A6etron_back_view'][colorCode]				
					}
					if (isFZ9_A6etronPackage == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ9_A6etron_front_view'][colorCode]
						imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ9_A6etron_back_view'][colorCode]				
					}
					// A6 etron

					// A7 C9
					if (isFZ8_A6_C9_Package == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ8_A6_C9_front_view'][colorCode]
						imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ8_A6_C9_back_view'][colorCode]			
					}
					if (isFZ9_A6_C9_Package == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ9_A6_C9_front_view'][colorCode]
						imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ9_A6_C9_back_view'][colorCode]	
					}
					// A7 C9

					// Q6 etron
					if (isFZ9Package == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ9_front_view'][colorCode]
						imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ9_back_view'][colorCode]	
						    if (front_seat_modell == 'Q4Q_AU41X_PERF') {
								imageSourceBack = aeo['images']['seatbelt_' + front_seat_modell + '_' + back_seat_modell + '_FZ9_back_view'][colorCode]
							}			
					}
					// Q6 etron

					// Q7/Q9 
					if (isFZ8_Q7_Q9_Package == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ8_Q7Q9_front_view'][colorCode]
						imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ8_Q7Q9_back_view'][colorCode]							
						if (carModelSeatbelt == 118 || carModelSeatbelt == 119 || carModelSeatbelt == 120) {
							imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ8_Q9_back_view'][colorCode]		
						}			
					}
					if (isFZ9_Q7_Q9_Package == true) {
						imageSourceFront = aeo['images']['seatbelt_' + front_seat_modell + '_FZ9_Q7Q9_front_view'][colorCode]
						imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ9_Q7Q9_back_view'][colorCode]							
						if (carModelSeatbelt == 118 || carModelSeatbelt == 119 || carModelSeatbelt == 120) {
							imageSourceBack = aeo['images']['seatbelt_' + back_seat_modell + '_FZ9_Q9_back_view'][colorCode]		
						}						
					}
					// Q7/Q9
				}	
				
			}
		default:
			break;
	}

	json.front = imageSourceFront
	json.back = imageSourceBack
	return json;

}

/** Gets frontseat and backseat images for seat-screen */
function getCustomizedSeatImage(seatType, component, colorCode, seatSelect){
	var carmodel = document.querySelector("input[name=carmodel]").value;
	if (seatType == 'frontSeat') {
		if (component == 'seatColor') {		
			if ((carmodel == 2) || (carmodel == 200)) {
				return aeo['images']['frontseat_RS_'+seatSelect+'_color'][colorCode];
			} else if (carmodel == 1) {
				return aeo['images']['frontseat_S_'+seatSelect+'_color'][colorCode];
			} else {
				return aeo['images']['frontseat_'+seatSelect+'_color'][colorCode];
			}
		} else if (component == 'stitchColor') {
			return aeo['images']['frontseat_'+seatSelect+'_stitch_color'][colorCode];
		} else if (component == 'bieseColor') {
			return aeo['images']['frontseat_'+seatSelect+'_biese_color'][colorCode]
		} else if (component == 'embossingColor') {
			return aeo['images']['frontseat_'+seatSelect+'_embossing_color'][colorCode]
		}
	}
	if (seatType == 'backSeat') {
		return component == 'seatColor' ?
			aeo['images']['backseat_'+seatSelect+'_color'][colorCode] : aeo['images']['backseat_'+seatSelect+'_stitch_color'][colorCode]
	}
}

/** Gets steering wheel images for screen-wheel */
function getSteeringWheelCustomizedComponentImage(component, colorCode){
	let steeringWheelModel_check = document.getElementsByName("steering-wheel-model")[0].value;
	var steeringWheelModel = steeringWheelModel_check;
	const color = parseInt(colorCode)

	if (steeringWheelModel <= 2) {
		let isHourMarkSteeringWheel = aeo['configuration']['YVN'] == true
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (isHourMarkSteeringWheel && ['top','sides','bottom','stitches'].indexOf(component)==-1){
			return aeo['paths']['hour_mark_steering_wheel'][colorCode] + aeo['components']['steering_wheel'][component]
		}else{
			if(['hourMark','stitchHourMark'].indexOf(component)!=-1){ //invalidComponent
				return ""
			}
		}
		var modelPath = steeringWheelModel == 1 ? 'model_onehundredone_car_steering_wheel' : 'model_two_car_steering_wheel';
		return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel'][component+"Color"];
	}

	let isGearLever = aeo['configuration']['YVU'] == true
	let isAirbagCover = aeo['configuration']['YUH'] == true	

	if (steeringWheelModel == 101) {
		let isHourMarkSteeringWheel = aeo['configuration']['YVN'] == true || aeo['configuration']['YVN_without12h'] == true;
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (isHourMarkSteeringWheel){
			if (component == "stitchHourMark") {	
				return aeo['paths']['stitch_hour_mark_steering_wheel_onehundreone'][colorCode]	
			}
			if (component == "hourMark") {
				return aeo['paths']['hour_mark_steering_wheel_onehundreone'][colorCode]
				}
			if (component == "top") {
				return aeo['paths']['topColor_steering_wheel_onehundreone'][colorCode]
			}
		}else{
		}		
		var modelPath = 'model_onehundredone_car_steering_wheel';
		return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel'][component+"Color"];
	}

	if (steeringWheelModel == 102) {
		let isHourMarkSteeringWheel = aeo['configuration']['YVN'] == true || aeo['configuration']['YVN_without12h'] == true;
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (isHourMarkSteeringWheel){
			if (component == "stitchHourMark") {			
				return aeo['paths']['stitch_hour_mark_steering_wheel_onehundretwo'][colorCode]	
			}
			if (component == "hourMark") {
				return aeo['paths']['hour_mark_steering_wheel_onehundretwo'][colorCode]
			}
			if (component == "top") {
				return aeo['paths']['topColor_steering_wheel_onehundretwo'][colorCode]
			}
		}else{
		}
		var modelPath = 'model_onehundredtwo_car_steering_wheel';
		return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel'][component+"Color"];
	}

	if (steeringWheelModel == 103) {
		let isHourMarkSteeringWheel = aeo['configuration']['YVN'] == true || aeo['configuration']['YVN_without12h'] == true;
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (isHourMarkSteeringWheel){
			if (component == "stitchHourMark") {			
				return aeo['paths']['stitch_hour_mark_steering_wheel_onehundrethree'][colorCode]	
			}
			if (component == "hourMark") {
				return aeo['paths']['hour_mark_steering_wheel_onehundrethree'][colorCode]
			}
			if (component == "top") {
				return aeo['paths']['topColor_steering_wheel_onehundrethree'][colorCode]
			}
		}else{
		}
		var modelPath = 'model_onehundredthree_car_steering_wheel';
		return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel'][component+"Color"];
	}

	if (steeringWheelModel == 107) {
		let isHourMarkSteeringWheel = aeo['configuration']['YVQ_etronGT'] == true;
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
			if (component == "top") {
				return aeo['paths']['topColor_steering_wheel_YVQ_etronGT'][colorCode]
			}
		var modelPath = 'model_YVQ_etronGT_car_steering_wheel';
		return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel'][component+"Color"];
	}	


	if (steeringWheelModel == 3){

		
		modelPath = 'A6A7_steering_wheel_2ZB';	
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];	
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];	
		} else {
			if (isAirbagCover) {	
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component];
				}else if(component == 'AirbagCoverStitches'){			
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component];
				}
			} 			
			return ""
		}



	} else if (steeringWheelModel == 4){

		modelPath = 'A6A7_steering_wheel_1XW_1XP_L';
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];			
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];	
		} else {
			if (isAirbagCover) {
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
				}else if(component == 'AirbagCoverStitches'){				
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
				}
			} 			
			return ""
		}

	} else if (steeringWheelModel == 5){

		modelPath = 'A6A7_steering_wheel_1XW_1XP_P';
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];			
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		} else {
			if (isAirbagCover) {
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
				}else if(component == 'AirbagCoverStitches'){				
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
				}
			} 			
			return ""
		}

	} else if (steeringWheelModel == 6){

		modelPath = 'A6A7_steering_wheel_2PF_L';
		
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];			
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];	
		} else {
			if (isAirbagCover) {
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
				}else if(component == 'AirbagCoverStitches'){				
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
				}
			} 			
			return ""
		}

	} else if (steeringWheelModel == 7){

		modelPath = 'A6A7_steering_wheel_2PF_P';
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];		
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];	
		} else {
			if (isAirbagCover) {
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
				}else if(component == 'AirbagCoverStitches'){				
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
				}
			} 			
			return ""
		}		

	} else if (steeringWheelModel == 8){

		modelPath = 'A6A7_steering_wheel_1XPF';
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];		
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];	
		} else {
			if (isAirbagCover) {
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
				}else if(component == 'AirbagCoverStitches'){				
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
				}
			} 			
			return ""
		}		

	} else if (steeringWheelModel == 9){

		modelPath = 'A6A7_steering_wheel_2PZ';
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];		
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];	
		} else {
			if (isAirbagCover) {
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
				}else if(component == 'AirbagCoverStitches'){				
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
				}
			} 			
			return ""
		}		


	} else if (steeringWheelModel == 10){

		modelPath = 'R6R7_steering_wheel_2PZ';
		if (component == 'GearLeverStitches') {
			return aeo['paths']['A6A7_gear_lever_1'][colorCode] + aeo['components']['steering_wheel_1'][component];		
		}else if(component == 'stitches'){				
			return aeo['paths'][modelPath][color] + aeo['components']['steering_wheel_1'][component+"Color"];	
		} else {
			if (isAirbagCover) {
				if (component == 'AirbagCoverLeather') {
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]				
				}else if(component == 'AirbagCoverStitches'){		
					return aeo['paths']['airbag_cover_2ZB'][colorCode] + aeo['components']['steering_wheel_1'][component]		
				}
			} 	
			return ""
		}

	} else if (steeringWheelModel == 13){		
		if (aeo['configuration']['YVU_Q7Q8'] == true) {	
			return aeo['paths']['steering_wheel_Q7_Q8_1XW_YVU'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		} else {
			return aeo['paths']['steering_wheel_Q7_Q8_Sport_Lenkrad_1XW_YVQ'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		}

	} else if (steeringWheelModel == 14){	
		return aeo['paths']['steering_wheel_SQ7_SQ8_1XW_YVU'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 15){	
		return aeo['paths']['steering_wheel_SQ7_SQ8_Sportkontur_Lenkrad_2PF_YVU'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 16){	
		return aeo['paths']['steering_wheel_RSQ8_Sport_Lenkrad_1XW_YVU'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 17){	
		return aeo['paths']['steering_wheel_Sportkontur_Lenkrad_2PF_YVU'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 18){	
		if (aeo['configuration']['YVU_Q7Q8'] == true) {	
			return aeo['paths']['steering_wheel_Q7_Q8_1XW_YVU'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		} else {
			return aeo['paths']['steering_wheel_Q7_Q8_Sport_Lenkrad_1XW_YVQ'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		}
		
	} else if (steeringWheelModel == 19){	
		return aeo['paths']['steering_wheel_SQ7_SQ8_Sport_Lenkrad_1XW_YVQ'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 20){	
		return aeo['paths']['steering_wheel_SQ7_SQ8_Sportkontur_Lenkrad_2PF_YVQ'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 21){	
		return aeo['paths']['steering_wheel_RSQ8_Sport_Lenkrad_1XW_YVQ'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 22){	
		return aeo['paths']['steering_wheel_RSQ8_Sportkontur_Lenkrad_2PF_YVQ'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	// A8	
	} else if (steeringWheelModel == 51){	
		return aeo['paths']['steering_wheel_A8_4_speichen_Schwarz_Lenkrad_2ZB'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 52){	
		return aeo['paths']['steering_wheel_A8_3_speichen_Schwarz_Lenkrad_1XW'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	// A8	
		
	// Q6 e-tron	
	} else if (steeringWheelModel == 60){	
		return aeo['paths']['steering_wheel_Q6_etron_2ZB_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];		
	} else if (steeringWheelModel == 61){	
		return aeo['paths']['steering_wheel_Q6_etron_2FS_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	} else if (steeringWheelModel == 62){	
		return aeo['paths']['steering_wheel_Q6_etron_1XY_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	// Q6 e-tron	
	
	// SQ6 etron performance
	} else if (steeringWheelModel == 63){	

		let isHourMarkSteeringWheel = aeo['configuration']['0UD_SQ6_perf'] == true
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (['sides','bottom','stitches'].indexOf(component)==-1){
				
			return aeo['paths']['steering_wheel_SQ6_perf_6F6_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component]

		}else{
			if(['hourMark','stitchHourMark'].indexOf(component)!=-1){ //invalidComponent
				return ""
			}
		}
		var modelPath = steeringWheelModel == 1 ? 'model_onehundredone_car_steering_wheel' : 'model_two_car_steering_wheel';
		return aeo['paths']['steering_wheel_SQ6_perf_6F6_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];

	} else if (steeringWheelModel == 64){	

		let isHourMarkSteeringWheel = aeo['configuration']['0UQ_SQ6_perf'] == true
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (['sides','bottom','stitches'].indexOf(component)==-1){
				
			return aeo['paths']['steering_wheel_SQ6_perf_6F9_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component]

		}else{
			if(['hourMark','stitchHourMark'].indexOf(component)!=-1){ //invalidComponent
				return ""
			}
		}
		var modelPath = steeringWheelModel == 1 ? 'model_onehundredone_car_steering_wheel' : 'model_two_car_steering_wheel';
		return aeo['paths']['steering_wheel_SQ6_perf_6F9_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	// SQ6 etron performance

	// A5	
	} else if (steeringWheelModel == 70){	
		return aeo['paths']['steering_wheel_A5_2ZQ_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];		
	} else if (steeringWheelModel == 71){	
		return aeo['paths']['steering_wheel_A5_2FS_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	} else if (steeringWheelModel == 72){	
		return aeo['paths']['steering_wheel_A5_1XY_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	} else if (steeringWheelModel == 73){	

		let isHourMarkSteeringWheel = aeo['configuration']['0UD_RS5'] == true
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (['top','sides','bottom','stitches'].indexOf(component)==-1){
		
			if (component == "top") {
				return aeo['paths']['topColor_steering_wheel_RS5_2ZC_SteeringWheel'][colorCode]
			}			
			return aeo['paths']['steering_wheel_RS5_2ZC_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component]

		}else{
			if(['hourMark','stitchHourMark'].indexOf(component)!=-1){ //invalidComponent
				return ""
			}
		}
		var modelPath = steeringWheelModel == 1 ? 'model_onehundredone_car_steering_wheel' : 'model_two_car_steering_wheel';
		return aeo['paths']['steering_wheel_RS5_2ZC_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
		
	} else if (steeringWheelModel == 74){	

		let isHourMarkSteeringWheel = aeo['configuration']['0UD_RS5'] == true
		if (steeringWheelModel == null || steeringWheelModel == "") return "";
		if (['top','sides','bottom','stitches'].indexOf(component)==-1){
		
			if (component == "top") {
				return aeo['paths']['topColor_steering_wheel_RS5_2ZC_Dinamica_SteeringWheel'][colorCode]
			}			
			return aeo['paths']['steering_wheel_RS5_2ZC_Dinamica_SteeringWheel'][colorCode] + aeo['components']['steering_wheel_1'][component]

		}else{
			if(['hourMark','stitchHourMark'].indexOf(component)!=-1){ //invalidComponent
				return ""
			}
		}
		var modelPath = steeringWheelModel == 1 ? 'model_onehundredone_car_steering_wheel' : 'model_two_car_steering_wheel';
		return aeo['paths']['steering_wheel_RS5_2ZC_Dinamica_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	// A5
		
	// A6 etron	
	} else if (steeringWheelModel == 80){	
		return aeo['paths']['steering_wheel_A6_etron_2ZQ_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];		
	} else if (steeringWheelModel == 81){	
		return aeo['paths']['steering_wheel_A6_etron_2FS_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	} else if (steeringWheelModel == 82){	
		return aeo['paths']['steering_wheel_A6_etron_1XY_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	// A6 etron	
		
	// A7 C9	
	} else if (steeringWheelModel == 90){	
		return aeo['paths']['steering_wheel_A6_C9_2ZQ_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];		
	} else if (steeringWheelModel == 91){	
		return aeo['paths']['steering_wheel_A6_C9_2FS_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	} else if (steeringWheelModel == 92){	
		return aeo['paths']['steering_wheel_A6_C9_1XY_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	// A7 C9
		
	// Q7/Q9 G8	
	} else if (steeringWheelModel == 104){
		return aeo['paths']['steering_wheel_Q7Q9_2ZQ_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];		
	} else if (steeringWheelModel == 105){	
		return aeo['paths']['steering_wheel_Q7Q9_2FS_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	} else if (steeringWheelModel == 106){	
		return aeo['paths']['steering_wheel_Q7Q9_1XY_SteeringWheel'][color] + aeo['components']['steering_wheel_1'][component+"Color"];
	}
	// Q7/Q9 G8	
}

/** Gets color basic images */
function getColorImage(colorCode) {
	return aeo['images']['color_tiles'][colorCode]
}

export { getInteriorImageForStoredComponent, getCustomizedSeatImage, getSteeringWheelCustomizedComponentImage,
	getColorImage }
